import 'rev-shared/bootstrap/SharedImports';

import { bootstrapAngularApp } from 'rev-shared/bootstrap/AngularAppBootstrapUtils';
import { EmbedWebcastModule } from './EmbedWebcast.Module';

bootstrapAngularApp(EmbedWebcastModule);
